import React from 'react';
import Chart from 'react-apexcharts';

const SalaryChart = ({ SalaryChartData }) => {
    const series = [
        { name: 'Base Salary', data: SalaryChartData.map(item => item.salary) },
        { name: 'OT Salary', data: SalaryChartData.map(item => item.overTimeSalary) },
        { name: 'Payment', data: SalaryChartData.map(item => item.totalPayment) },
    ];

    const options = {
        chart: { 
            type: 'area', 
            height: 300, 
            toolbar: { 
                show: false 
            },
            zoom: {
                enabled: false, // 🚫 Disable zoom
            },
        },
        colors: ["#008ffb", "#00e396", "#ff0000"],
        dataLabels: { enabled: false },
        stroke: { 
            curve: 'smooth',
            width: 2,
        },
        xaxis: {
            type: 'category',
            categories: SalaryChartData.map(item => new Date(item.date).getDate()),
            tickAmount: Math.min(SalaryChartData.length, 10), // auto group ticks based on chart size
            labels: {
                formatter: val => val, // show day number
            },
        },
        tooltip: { 
            x: { 
                formatter: val => `Day ${val}` 
            },
            y: {
                formatter: (val) => `₹${val}`, // 👈 Add Rupee symbol here
            }, 
        },
        responsive: [
            {
                breakpoint: 600, // small screens
                options: {
                    xaxis: {
                        tickAmount: Math.min(SalaryChartData.length, 5), // fewer labels
                    },
                },
            },
        ],
    };

    return <Chart options={options} series={series} type="area" height={285} />;
};

export default SalaryChart;
